import {
	reRegionsConstants
}from "./constants"
import api from "./api"
import districtApi from "../ReDistricts/api"
import adminTerrApi from "../ReAdministrativeTerritories/api"
import {
	reAdministrativeTerritoriesConstants
}from "../ReAdministrativeTerritories/constants"
import {
	reDistrictActions
}from "../ReDistricts/actions"
import {
	reDistrictsConstants
}from "../ReDistricts/constants"
import {
	reAdministrativeTerritoryActions
}from "../ReAdministrativeTerritories/actions"
import {
	appealsActions
}from "../../Appeals/store/actions"

export const reRegionActions = {
	getForFilterCallback,
	getRegions,
	getRegionByName,
	createRegion,
	deleteRegion,
	updateRegion,
	restoreRegion,
	clear
}

function getRegions(params){
	return (dispatch) => {
		dispatch(request())

		api
			.getRegions(params)
			.then((res) => {
				dispatch(success(res))
			})
			.catch((e) => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reRegionsConstants.SEND_REREGIONS_REQUEST
			}
		}
		function success(regions){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_SUCCESS,
				payload : regions
			}
		}
		function failure(error){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_FAILURE,
				payload : error
			}
		}
	}
}

function clear(){
	return (dispatch) => {
		dispatch(request())
		function request(){
			return {
				type: reRegionsConstants.CLEAR_REREGIONS
			}
		}
	}
}

function getRegionByName(params){
	return (dispatch) => {
		dispatch(request())

		api
			.getRegionByName(params)
			.then((res) => {
				dispatch(success(res))
			})
			.catch((e) => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reRegionsConstants.SEND_REREGIONS_REQUEST
			}
		}
		function success(regions){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_SUCCESS,
				payload : regions
			}
		}
		function failure(error){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_FAILURE,
				payload : error
			}
		}
	}
}
function createRegion(params){
	return (dispatch) => {
		dispatch(request())

		api
			.createRegion(params)
			.then((res) => {
				dispatch(success(res))
			})
			.catch((e) => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reRegionsConstants.SEND_REREGIONS_REQUEST
			}
		}
		function success(regions){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_SUCCESS,
				payload : regions
			}
		}
		function failure(error){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_FAILURE,
				payload : error
			}
		}
	}
}

function deleteRegion(params){
	return (dispatch) => {
		dispatch(request())

		api
			.deleteRegion(params)
			.then((res) => {
				dispatch(success(res))
				res
			})
			.catch((e) => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reRegionsConstants.SEND_REREGIONS_REQUEST
			}
		}
		function success(regions){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_SUCCESS,
				payload : regions
			}
		}
		function failure(error){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_FAILURE,
				payload : error
			}
		}
	}
}

function updateRegion(params){
	return (dispatch) => {
		dispatch(request())

		api
			.updateRegion(params)
			.then((res) => {
				dispatch(success(res))
			})
			.catch((e) => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reRegionsConstants.SEND_REREGIONS_REQUEST
			}
		}
		function success(regions){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_SUCCESS,
				payload : regions
			}
		}
		function failure(error){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_FAILURE,
				payload : error
			}
		}
	}
}

function restoreRegion(params){
	return (dispatch) => {
		dispatch(request())

		api
			.restoreRegion(params)
			.then((res) => {
				dispatch(success(res))
			})
			.catch((e) => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reRegionsConstants.SEND_REREGIONS_REQUEST
			}
		}
		function success(regions){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_SUCCESS,
				payload : regions
			}
		}
		function failure(error){
			return {
				type    : reRegionsConstants.SEND_REREGIONS_FAILURE,
				payload : error
			}
		}
	}
}

function getAdministrativeTerritoryByName(params){
	return dispatch => {
		dispatch(request())

		adminTerrApi.getTerr(params).then(res => {
			dispatch(success(res))
			dispatch(appealsActions.setFilter({
				name  : 'administrativeterritory',
				value : res[0]
			}))
		})
			.catch(e => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reAdministrativeTerritoriesConstants.SEND_READMINISTRATIVETERRITORIES_REQUEST
			}
		}
		function success(administrativeTerritories){
			return {
				type    : reAdministrativeTerritoriesConstants.SEND_READMINISTRATIVETERRITORIES_SUCCESS,
				payload : administrativeTerritories
			}
		}
		function failure(error){
			return {
				type    : reAdministrativeTerritoriesConstants.SEND_READMINISTRATIVETERRITORIES_FAILURE,
				payload : error
			}
		}
	}
}

function getForFilterCallback(value){
	if (value && value.name == 'Минск'){
		return (dispatch) => {
			dispatch(request())

			districtApi
				.getDistrictByName({
					page       : 1,
					pageSize   : 100,
					name       : 'Минский',
					regionCode : null
				})
				.then((res) => {
					dispatch(success(res))
					dispatch(appealsActions.setFilter({
						name  : 'district',
						value : res?.items[0]
					}))
					dispatch(getAdministrativeTerritoryByName({
						name       : "Минск",
						regionId   : value.id,
						districtId : res?.items[0]?.id
					}))
				})
				.catch((e) => {
					dispatch(failure(e))
				})

			function request(){
				return {
					type: reDistrictsConstants.SEND_REDISTRICTS_REQUEST
				}
			}
			function success(districts){
				return {
					type    : reDistrictsConstants.SEND_REDISTRICTS_SUCCESS,
					payload : districts
				}
			}
			function failure(error){
				return {
					type    : reDistrictsConstants.SEND_REDISTRICTS_FAILURE,
					payload : error
				}
			}
		}
	}
	return (dispatch) => {
	}
}